var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoNoneMembership = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.8 6.5h-6.586A2.214 2.214 0 0 0 12 8.715v6.57c0 1.223.992 2.215 2.214 2.215h6.571A2.215 2.215 0 0 0 23 15.285V8.7a2.2 2.2 0 0 0-2.2-2.2Z",
  fill: "#2D91FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.8 6.5H3.214C1.992 6.5 1 7.49 1 8.714v6.571c0 1.223.992 2.215 2.214 2.215h6.571A2.215 2.215 0 0 0 12 15.285V8.7a2.2 2.2 0 0 0-2.2-2.2Z",
  fill: "#1A2E82"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.178 15.234a.714.714 0 1 1-1.428 0 .714.714 0 0 1 1.428 0Z",
  fill: "#2D91FF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.814 12.722c-.234 0-.466.152-.588.306-.371.429-.865.766-1.515.766a1.786 1.786 0 0 1-1.794-1.777c0-.95.773-1.776 1.794-1.776.65 0 1.144.337 1.515.766.122.154.357.306.588.306.428 0 .722-.323.722-.68a.75.75 0 0 0-.119-.423C8.833 9.35 7.891 8.8 6.711 8.8c-1.825 0-3.248 1.41-3.248 3.216 0 1.807 1.423 3.216 3.248 3.216 1.175 0 2.122-.549 2.706-1.409a.737.737 0 0 0 .119-.424c0-.353-.296-.679-.722-.679",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.178 15.234a.714.714 0 1 1-1.428 0 .714.714 0 0 1 1.428 0Z",
  fill: "#2D91FF"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 8.8a.714.714 0 0 0-.714.715v4.974a.714.714 0 1 0 1.428 0V9.516A.714.714 0 0 0 17.5 8.8Z",
  fill: "#fff"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7 12.003a.714.714 0 0 0-.714-.714h-4.972a.714.714 0 0 0 0 1.429h4.972c.394 0 .714-.32.714-.715Z",
  fill: "#fff"
})));
export default SvgLogoNoneMembership;